import React, { useEffect, useState, } from "react";
import Col from "react-bootstrap/Col";
import Modal from "react-bootstrap/Modal";
import Row from "react-bootstrap/Row";
import { InputField } from "../../../../Components/formElements/InputField";
import ItemService from "../../../../services/customer_appCommonService";
import { TextAreaField } from "../../../../Components/formElements/TextAreaField";
import { ComboboxField } from "../../../../Components/formElements/ComboboxField";
import FailureModal from "../../../../Components/Modal/supplier_app/FailureModal";
import FileUploadComponent from "../../../../Components/formElements/FileUploadComponent";
import FileViewerModal from "../../../../Components/FileViewer/FileViewerModal";
import toast from "react-hot-toast";
import { getTodaysData } from "../../../../common/Validations";
import CustomerConstants from "../../../../common/CustomerConstants";
import { useNavigate } from "react-router-dom";
import { getQtnJobList } from "../../../../redux/feature/customer_app/customerV1Slice";
import { useDispatch, useSelector } from "react-redux";
// import { ChevronsUp } from "lucide-react";

const QuotationRevisionUpdate = React.forwardRef((props, ref) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [disabled, setDisabled] = useState(false);
  const [getDropdownData /*setDropdownData*/] = useState("");
  const [getShowFileViewModal, setShowFileViewModal] = useState(false);
  const [getFileViewData, setFileViewData] = useState(null);
  const failureCashRequest = {
    title: "Warning",
    ErrorMsg: "",
  };

  const [getFailureCashRequest] = useState(failureCashRequest);
  const [getShowFailureModal, setShowFailureCashRequest] = useState(false);

  let documentNumber = useSelector(
    (state) => state?.customerV1?.quotation_Job?.quotation_JobNr
  ); // User Details from Store

  useEffect(() => {
    if (!getDropdownData) return;
    setQuotationRequest((prev) => ({
      ...prev,
      [getDropdownData?.textField]: getDropdownData?.name,
      [getDropdownData?.textCode]: getDropdownData?.textCode,
      [getDropdownData?.textDesc]: getDropdownData?.textDesc,
    }));
    if (getDropdownData?.textField === "typeS") {
      setQuotationRequest((prev) => ({
        ...prev,
        typeS: getDropdownData?.name,
      }));
      if (getDropdownData.textField === "checkerName") {
        setQuotationRequest((prev) => ({
          ...prev,
          checkerName: getDropdownData.name,
          checkerNameCode: getDropdownData.textCode,
          checkerNameDesc: getDropdownData.textDesc,
        }));
      }
    }
  }, [getDropdownData]);

  //Validations
  // const [, /*validation*/ setValidation] = useState({
  //   cashRequestNr: "",
  //   cashRequestStatus: "",
  //   salesOfficerCode: "",
  //   salesOfficerName: "",
  //   customerCode: "",
  //   customerName: "",
  //   paymentPurpose: "",
  //   paymentMode: "",
  //   cashAmount: "",
  //   cashAmountInWords: "",
  //   receivedBy: "",
  //   receiverContactNumber: "",
  // });
  //Customer drop down

  useEffect(() => {
    const handleEscapeKey = (event) => {
      if (event.key === "Escape" || event.keyCode === 27) {
        props.onHide();
      }
    };
    document.addEventListener("keydown", handleEscapeKey);
    return () => {
      document.removeEventListener("keydown", handleEscapeKey);
    };
  }, [props]);

  const initialState = {
    transactionDate: getTodaysData() || "",
    clientName: "",
    companyName: "",
    location: "",
    validUntil: "",
    tenestinationDate: getTodaysData() || "",
    qtn_Job_RefNr: "",
    salesOfficerName: "",
    headerStatus: "",
    transactionCodeType: "",
    qtn_Job_Remarks: "",
  };

  const typeS = [
    { id: 1, name: "Job", transactionCodeType: "JB" },
    { id: 2, name: "Quotation", transactionCodeType: "QTN" },
  ];
  const checkerName = [
    { id: 1, name: "Sai Ganandeep" },
    { id: 2, name: "Md Zuber" },
    { id: 3, name: "Gulnaz" },
    { id: 4, name: "Sandeep Kumar C" },
    { id: 4, name: "Shakuntahala K" },
  ];

  const [selectedType, setSelectedType] = useState(null);

  const [quotationRequest, setQuotationRequest] = useState({
    transactionDate: getTodaysData() || "",
    clientCompanyName: "",
    projectName: "",
    location: "",
    validUntil: "",
    estimationDate: getTodaysData() || "",
    salesOfficerName: "",
    headerStatus: "",
    transactionCodeType: "",
    qtn_Job_Remarks: "",
    type: "",
    designerName: "",
    revisionUpdatedDate: getTodaysData() || "",
    // revision: "R0",
    version: "V0",
    convertJobtStatus:"",
  });

  // Update quotationRequest when user selects a type
  useEffect(() => {
    if (selectedType) {
      setQuotationRequest((prev) => ({
        ...prev,
        type: selectedType.name,
        transactionCodeType: selectedType.transactionCodeType,
        headerStatus:
          selectedType.transactionCodeType === "QTN"
            ? "Quotation Created"
            : selectedType.transactionCodeType === "JB"
            ? "Job Created"
            : "",
      }));
    }
  }, [selectedType]);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setQuotationRequest((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const onSuccessUploadDocumentType = (data) => {
    setQuotationRequest((formInputs) => ({
      ...formInputs,
      [data.fieldName]: data.attachmentId,
    }));
  };
  const handleViewFile = (fileAttachmentId) => {
    setFileViewData(fileAttachmentId);
    setShowFileViewModal(true);
  };
  const handleViewFileHide = () => {
    setShowFileViewModal(false);
  };

  //handle cancel modal
  const handleCancel = () => {
    setQuotationRequest((prev) => ({ ...prev, ...initialState }));
    props.onHide();
  };

  const handleInputChanges = (e) => {
    const { name, value } = e.target;
    setQuotationRequest((prev) => ({
      ...prev,
      [name]: value.toUpperCase(),
    }));
  };

  const loadFirstLevelData = async (queryName) => {
    if (documentNumber) {
      let obj = {
        queryName: queryName,
        documentNumber: documentNumber,
      };
console.log(">>obje load frist level:", obj);
      await ItemService.generateCustomerQuery(obj).then((item) => {
        console.log("loadFirstLevelData:", item);
        if (item?.status === 200) {
          setQuotationRequest(item?.data[0]);
          // setPOLineItemsData(item?.data[0]?.items);
        } else {
          setQuotationRequest([]);
          console.log(`>> Error: Loading ${queryName}`);
        }
      });
    } else {
      // navigate(Constants.PRESALES_INQUIRY_LIST);
    }
  };

  useEffect(() => {
    // loadFirstLevelData("Get_JOB_DETAIL");
    loadFirstLevelData("Get_QUOTATION_DETAIL");

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [documentNumber]);

  const hideFailureModal = () => {
    setShowFailureCashRequest(false);
  };

  // const handleUpdate = async () => {
  //   let currentRevision = quotationRequest?.version;
  //   let nextRevision = "V" + (parseInt(currentRevision?.replace("V", "")) + 1);

  //   let obj = {
  //     ...quotationRequest,
  //     version: nextRevision,
  //     documentNumber: documentNumber,
  //   };

  //   await ItemService.updateQuotationOrJob(obj).then(async (item) => {
  //     if (item?.status === 200) {
  //       toast.success(item?.message || "Revision Job Updated successfully", {
  //         duration: 2000,
  //         position: "top-right",
  //       });

  //       setQuotationRequest((prev) => ({
  //         ...prev,
  //         version: nextRevision,
  //       }));

  //       props.onHide();

  //       await dispatch(
  //         getQtnJobList({
  //           queryName: "Get_QUOTATION_LIST",
  //           module: "",
  //           page: 1,
  //           per_page: 10,
  //         })
  //       );

  //       navigate(CustomerConstants.CUSTOMER_V4_HB_QUOTATION_LIST);
  //     } else {
  //       toast.error(item?.message || "Please try again !!", {
  //         duration: 4000,
  //         position: "top-right",
  //       });
  //     }

  //     setDisabled(false);
  //   });
  // };


  const handleUpdate = async () => {
  let currentRevision = quotationRequest?.version || "V0"; 
  let numericValue = parseInt(currentRevision.replace("V", ""));

  // if numericValue is NaN → default to 0
  numericValue = isNaN(numericValue) ? 0 : numericValue;

  let nextRevision = "V" + (numericValue + 1);

  let obj = {
    ...quotationRequest,
    version: nextRevision,
    documentNumber: documentNumber,
    transactionCodeType:"QTN"    
  };
  

  await ItemService.reviseQuotationOrJob(obj).then(async (item) => {
    // console.log("update:", item);
    if (item?.status === 200) {
      toast.success(item?.message || "Revision Job Updated successfully", {
        duration: 2000,
        position: "top-right",
      });

      setQuotationRequest((prev) => ({
        ...prev,
        version: nextRevision,
      }));

      props.onHide();

      await dispatch(
        getQtnJobList({
          queryName: "Get_QUOTATION_LIST",
          module: "",
          page: 1,
          per_page: 10,
        })
      );

      navigate(CustomerConstants.CUSTOMER_V4_HB_QUOTATION_LIST);
//       setTimeout(() => {
//   window.location.reload();
// }, 200);
    } else {
      toast.error(item?.message || "Please try again !!", {
        duration: 4000,
        position: "top-right",
      });
    }

    setDisabled(false);
  });
};
// for converting job

  const handleQuotationToJob = async () => {
      
    let obj = {

  data: {
      ...quotationRequest,
        transactionCodeType: "JB",     // your additional field
    quotationNr: quotationRequest?.quotationNr,       // QU0231
    jobReferenceNr: quotationRequest?.qtnReferenceNr || "", 
    qtnReferenceNr: quotationRequest?.qtnReferenceNr, // QT-AATRL-003
    remarks: quotationRequest?.remarks || "",
    headerStatus: "Job Created",
    estHeaderStatus: "Estimation Pending",
    enquiryNr: quotationRequest?.enquiryNr,
    type:"Job",
    convertJobtStatus:"Job Converted"
  }
};
// console.log("obj",obj)
  
      try {
        const item = await ItemService.convertQuotationToJob(obj);
  
        if (item?.status === 200) {
          toast.success(item?.message || "Added successfully", {
            duration: 2000,
            position: "top-right",
          });
  
          props.onHide();
          dispatch(
            getQtnJobList({
              queryName: "Get_JOB_LIST",
              module: "",
              page: 1,
              per_page: 10,
            })
          );
          navigate(CustomerConstants.CUSTOMER_V4_HB_JOB_LIST);
        } else {
          toast.error(item?.message || "Please try again !!", {
            duration: 4000,
            position: "top-right",
          });
        }
      } catch (err) {
        console.error("Error:", err);
        toast.error("Something went wrong!", {
          duration: 4000,
          position: "top-right",
        });
      } finally {
        // setIsSaving(false);
        setDisabled(false);
      }
    };


  return (
    <Modal
      {...props}
      aria-labelledby="contained-modal-title-vcenter"
      keyboard={false}
      size="xl"
      ref={ref}
      centered
      backdrop="static"
    >
      <Modal.Header closeButton>
        <Modal.Title id="contained-modal-title-vcenter">
          Quotation Revision Update
          <span className="bg-table-status bg-table-documentNumber-status headerStatusDetailedPage text-sm px-2 py-1">
            {quotationRequest?.qtnReferenceNr}
          </span>
          <span className="bg-table-status bg-table-success-status headerStatusDetailedPage text-sm px-2 py-1 ms-2">
            {quotationRequest?.version}
          </span>
        </Modal.Title>
      </Modal.Header>
      <Modal.Body className="">
        {/*03 */}
        <div className="accordion mb-4" id="accordionExample">
          <div className="accordion-item">
            <h2 className="accordion-header">
              <Row className="accordion-button">
                <Col xs={1} md={1} lg={1} className="text-center logoBtn">
                  <span className="iconLogo">BI</span>
                </Col>

                <Col xs={4} md={4} lg={4}>
                  <span className="headerTitle">Basic Information</span>
                  {/* <span className="subHeaderTitle">Inquire Details</span> */}
                </Col>
              </Row>
            </h2>

            <div>
              <div className="accordion-body">
                <Row>
                  <Col xs={12} md={12} lg={12}>
                    <div className="accordion-body">
                      <Row className="pt-2 pb-4">
                        <Col
                          xs={12}
                          md={6}
                          lg={4}
                          className="commTopButtonRightLeftPadding"
                        >
                          <InputField
                            className="inputBox"
                            type="date"
                            label="Date"
                            name="transactionDate"
                            id="transactionDate"
                            value={quotationRequest?.transactionDate}
                            onChange={handleInputChange}
                          />
                        </Col>
                        <Col
                          xs={12}
                          md={6}
                          lg={4}
                          className="commLeftRightPadding"
                        >
                          <InputField
                            className="inputBox"
                            label="Client Name"
                            name="clientName"
                            id="clientName"
                            value={quotationRequest?.clientName}
                            onChange={handleInputChanges}
                            disabled={true}
                          />
                        </Col>
                        <Col
                          xs={12}
                          md={6}
                          lg={4}
                          className="commLeftRightPadding"
                        >
                          <InputField
                            className="inputBox"
                            label="Company Name"
                            name="companyName"
                            id="companyName"
                            value={quotationRequest?.companyName}
                            onChange={handleInputChanges}
                            disabled={true}
                          />
                        </Col>
                        <Col
                          xs={12}
                          md={6}
                          lg={4}
                          className="commLeftRightPadding"
                        >
                          <InputField
                            className="inputBox"
                            label="Building name"
                            name="buildingName"
                            id="buildingName"
                            value={quotationRequest?.buildingName}
                            onChange={handleInputChanges}
                          />
                        </Col>
                        <Col
                          xs={12}
                          md={6}
                          lg={4}
                          className="commTopButtonRightLeftPadding"
                        >
                          <TextAreaField
                            className="inputBox"
                            label="Location"
                            placeholder=""
                            name="location"
                            id="location"
                            value={quotationRequest?.location}
                            onChange={handleInputChange}
                          />
                        </Col>
                        <Col
                          xs={12}
                          md={6}
                          lg={4}
                          className="commTopButtonRightLeftPadding"
                        >
                          <InputField
                            className="inputBox"
                            label="Sales Officer Name"
                            name="salesOfficerName"
                            id="salesOfficerName"
                            value={quotationRequest?.salesOfficerName}
                            onChange={handleInputChanges}
                            disabled={true}
                          />
                        </Col>
                        <Col
                          xs={12}
                          md={6}
                          lg={4}
                          className="commLeftRightPadding"
                        >
                          <ComboboxField
                            label="Type"
                            placeholder=""
                            data={typeS}
                            id="type"
                            iconClassName="dropdownIcon"
                            name="type"
                            code="typeCode"
                            description="name"
                            setValue={quotationRequest?.type}
                            getvalue={setSelectedType}
                            // required={true}
                            disabled={true}
                          />
                        </Col>
                        {quotationRequest?.type === "Job" && (
                          <>
                            <Col
                              xs={12}
                              md={6}
                              lg={4}
                              className="commTopButtonRightLeftPadding"
                            >
                              <InputField
                                className="inputBox"
                                label="Job Reference Number"
                                name="jobReferenceNr"
                                id="jobReferenceNr"
                                value={quotationRequest?.jobReferenceNr}
                                onChange={handleInputChange}
                                disabled={true}
                              />
                            </Col>
                          </>
                        )}
                        {quotationRequest?.type === "Quotation" && (
                          <>
                            <Col
                              xs={12}
                              md={6}
                              lg={4}
                              className="commTopButtonRightLeftPadding"
                            >
                              <InputField
                                className="inputBox"
                                label="Quotation Reference Number"
                                name="qtnReferenceNr"
                                id="qtnReferenceNr"
                                value={quotationRequest?.qtnReferenceNr}
                                onChange={handleInputChange}
                              />
                            </Col>
                          </>
                        )}
                        <Col
                          xs={12}
                          md={6}
                          lg={4}
                          className="commTopButtonRightLeftPadding"
                        >
                          <InputField
                            className="inputBox"
                            type="date"
                            label="Estimation Date"
                            name="estimationDate"
                            id="estimationDate"
                            value={quotationRequest?.estimationDate}
                            onChange={handleInputChange}
                          />
                        </Col>
                        <Col
                          xs={12}
                          md={6}
                          lg={4}
                          className="commTopButtonRightLeftPadding"
                        >
                          <InputField
                            className="inputBox"
                            label="Designer"
                            name="designerName"
                            id="designerName"
                            value={quotationRequest?.designerName}
                            onChange={handleInputChange}
                            disabled={true}
                          />
                        </Col>
                        <Col
                          xs={12}
                          md={6}
                          lg={4}
                          className="commLeftRightPadding"
                        >
                          <ComboboxField
                            label="Checker Name"
                            placeholder=""
                            data={checkerName}
                            id="checkerName"
                            iconClassName="dropdownIcon"
                            name="checkerName"
                            code="checkerNameCode"
                            description="name"
                            setValue={quotationRequest?.checkerName}
                            // getvalue={setSelectedType}
                            required={true}
                          />
                        </Col>
                        <Col
                          xs={12}
                          md={6}
                          lg={4}
                          className="commTopButtonRightLeftPadding"
                        >
                          <TextAreaField
                            className="inputBox"
                            label="Remarks"
                            placeholder=""
                            name="remarks"
                            id="remarks"
                            value={quotationRequest?.remarks}
                            onChange={handleInputChange}
                          />
                        </Col>
                        <Col
                          xs={12}
                          md={6}
                          lg={4}
                          className="commTopButtonRightLeftPadding"
                        >
                          <InputField
                            className="inputBox"
                            type="date"
                            label="Reivison Date"
                            name="revisionUpdatedDate"
                            id="revisionUpdatedDate"
                            value={quotationRequest?.revisionUpdatedDate}
                            onChange={handleInputChange}
                          />
                        </Col>
                        <Col
                          xs={12}
                          md={6}
                          lg={4}
                          className="commTopButtonRightLeftPadding"
                        >
                          <InputField
                            className="inputBox"
                            label="Revision"
                            name="version"
                            id="version"
                            value={quotationRequest?.version}
                            onChange={handleInputChange}
                            disabled={true}
                          />
                        </Col>
                        <Col
                          xs={12}
                          md={6}
                          lg={4}
                          className="commTopButtonRightLeftPadding"
                        >
                          <TextAreaField
                            className="inputBox"
                            label="Revision Remarks"
                            name="revisionRemarks"
                            id="revisionRemarks"
                            value={quotationRequest?.revisionRemarks}
                            onChange={handleInputChange}
                          />
                        </Col>
                        <Col
                          xs={12}
                          md={4}
                          lg={4}
                          className="commLeftRightPadding"
                        >
                          <FileUploadComponent
                            id="supportingDoc"
                            name="supportingDoc"
                            label="Supporting Document"
                            allowedTypes={[
                              "image/png",
                              "image/jpeg",
                              "application/pdf",
                            ]}
                            multiple={true} // Change to false for single file selection
                            required={true}
                            onSuccessUpload={onSuccessUploadDocumentType}
                            value={quotationRequest?.supportingDoc || ""}
                          />
                        </Col>
                        <Col
                          xs={12}
                          md={4}
                          lg={4}
                          className="commLeftRightPadding"
                        >
                          {(quotationRequest?.supportingDoc && (
                            <img
                              src="assets/img/newIcons/attached-file.png"
                              className="mt-1 attachmentIcon"
                              alt="attachments"
                              onClick={() =>
                                handleViewFile(quotationRequest?.supportingDoc)
                              }
                            />
                          )) ||
                            "--"}
                        </Col>
                      </Row>
                    </div>
                  </Col>
                </Row>
              </div>
            </div>
            {
              <Row className="my-4 ">
                <Col
                  lg={{ span: 2, offset: 8 }}
                  className="d-flex justify-content-end mt-2"
                >
                  <button
                    className="btnTable btn-danger"
                    onClick={handleCancel}
                    disabled={disabled}
                  >
                    Cancel
                  </button>
                </Col>
                <Col lg={2} className="d-flex justify-content-end mt-2">
                  <button
                    className="btnTable"
                    disabled={disabled}
                    onClick={handleUpdate}
                  >
                    Save
                  </button>
                </Col>
                <Col lg={2} className="d-flex justify-content-end mt-2">
                  <button
                    className="btnTable"
                    disabled={disabled}
                    onClick={handleQuotationToJob}
                  >
                    Convert ToJob
                  </button>
                </Col>
              </Row>
            }
          </div>
        </div>
        <FailureModal
          show={getShowFailureModal}
          onHide={hideFailureModal}
          failureStockData={getFailureCashRequest}
          // requiredfields={getErrorFields}
        />
        <FileViewerModal
          show={getShowFileViewModal}
          onHide={handleViewFileHide}
          fileid={getFileViewData}
        />
      </Modal.Body>
    </Modal>
  );
});

export default QuotationRevisionUpdate;
